/**
 * Spectacles ouverts à la réservation en ligne (entrée libre, places limitées).
 *
 * La JAUGE FAIT FOI CÔTÉ SERVEUR : `capacity` et `max_per_reservation` sont ici pour
 * l'affichage, mais c'est le backend (SPECTACLES_RESERVABLES dans server.py) qui décide
 * si une réservation est confirmée ou passe en liste d'attente. Les deux doivent rester
 * alignés.
 */
export const SPECTACLES_RESERVABLES = [
  {
    id: "noel-2026",
    title: "Spectacle de Noël 2026",
    subtitle: "Comédie Musicale · Soirée solidaire",
    date_label: "Lundi 7 décembre 2026",
    time_label: "19h00",
    doors_label: "Ouverture des portes à 18h30",
    location: "Maison Villageoise, Cugy VD",
    capacity: 250,
    max_per_reservation: 7,
    date_iso: "2026-12-07",
    heure_iso: "19:00",
    restauration: "Restauration sur place",
    association: { name: "Sea Shepherd Suisse", url: "https://www.seashepherd.ch/fr-ch/" },
    intro:
      "Les élèves de Comédie Musicale montent sur scène pour célébrer la magie de Noël. Entrée libre : un don est possible sur place, et l'intégralité des bénéfices est reversée à une association pour la préservation des océans.",
  },
];

export const reservationFor = (id) => SPECTACLES_RESERVABLES.find((s) => s.id === id) || null;
